import { Button, notification, Typography } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import { ItemType } from 'antd/lib/menu/hooks/useItems';

import { MainLayout } from 'components/Layout/MainLayout';
import { PageTitles } from 'constants/pageTitles';
import { useQuery } from 'hooks/useQuery';
import { useAppDispatch, useAppSelector } from 'store';
import {
  deleteRegulation,
  loadRegulationsList,
  setUnPublishRegulations,
} from 'store/slices/regulations/actions';
import {
  QueryFormValues,
  RegulationsItem,
} from 'store/slices/regulations/interfaces';
import { canBeUnPublished } from 'utils/rights';
import { StickyConfirmModal } from 'components/modals/StickyConfirmModal';
import { useDeepEffect } from 'utils/useDeepEffect';
import { StatusesEnum } from 'constants/status';

import { Filters } from './components/Filters';
import { TableRegulations } from './components/TableRegulations';

export const List = () => {
  const query = useQuery();
  const [sort, setSort] = React.useState<string | undefined>('');
  const [isRemoveModalIsOpen, setRemoveModalIsOpen] =
    React.useState<boolean>(false);
  const [currentItem, setCurrentItem] = React.useState(null);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { list, total, limit } = useAppSelector(state => state.regulations);

  const onCreateClick = () => navigate('add');

  const loadItems = () =>
    dispatch(loadRegulationsList({ ...(query as QueryFormValues), sort }));

  const handleUnPublish = async (id: number) => {
    await dispatch(setUnPublishRegulations(id))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Cущность успешно снята с публикации',
        });
        loadItems();
      });
  };

  useDeepEffect(() => {
    loadItems();
  }, [query, sort]);

  const buttonList = [
    <Button key={1} onClick={onCreateClick} type='primary'>
      Создать
    </Button>,
  ];

  const onRemoveModalClose = () => setRemoveModalIsOpen(false);

  const onRemoveClick = async () => {
    await dispatch(deleteRegulation({ id: currentItem.id }))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Cущность успешно удалена',
        });
        loadItems();
        onRemoveModalClose();
      });
  };

  const getActions = (item: RegulationsItem): ItemType[] => [
    {
      key: 'edit',
      label: <Link to={`/regulations/${item.id}/edit`}>Редактировать</Link>,
    },
    {
      key: 'unPublish',
      label: <Typography.Text>Снять с публикации</Typography.Text>,
      onClick: () => handleUnPublish(item?.id || 0),
      disabled: !canBeUnPublished(item),
    },
    {
      key: 'remove',
      label: 'Удалить',
      danger: true,
      onClick: () => {
        if (item.status === StatusesEnum.PUBLISHED) {
          notification.error({
            message: 'Необходимо снять сущность с публикации',
          });
        } else {
          setRemoveModalIsOpen(true);
          setCurrentItem(item);
        }
      },
    },
  ];

  return (
    <MainLayout
      pageTitle={PageTitles['regulations']}
      extraButtonsList={buttonList}
      aside={<Filters />}
    >
      <TableRegulations
        items={list}
        setSort={setSort}
        total={total}
        limit={limit}
        getActions={getActions}
      />
      <StickyConfirmModal
        isOpen={isRemoveModalIsOpen}
        onRequestClose={onRemoveModalClose}
        title='Удаление сущности'
        okText='Удалить'
        text='Вы действительно хотите удалить эту cущность?'
        onSubmit={onRemoveClick}
        okButtonProps={{ danger: true }}
      />
    </MainLayout>
  );
};
